import { SideNav, SideNavContent } from "components";
import {
  BaseSnackbar,
  HeaderDasNew,
  LargeButton,
  MainBody,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import React, { useEffect, useMemo, useState } from "react";
import { EmployeeDataWrapper, VerticalDivider } from "./styles";
import SpiralCompletion from "components/SpiralCompletion";
import http from "services/httpService";
import { formatDate, formatDateSequence } from "utlis/utils";
import useFlex from "hooks/useFlex";
import DatefieldWithIcon from "components/core/dateFieldWithIcon";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import routes from "components/routes";

const FlexDashboard = () => {
  const company_name = localStorage.getItem("company_name");
  const [companyName, setCompanyName] = useState("");
  const [sheetData, setSheetData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState();
  const [cutoffDate, setCutoffDate] = useState();
  const [error, setError] = useState();
  const [showDownloadFields, setShowDownladFields] = useState(false);
  const { resetCompletedProductList, removeListener } = useFlex();
  const navigate = useNavigate();
  const showSidebar = useMemo(() => {
    return (
      !!localStorage.getItem("id") && !!localStorage.getItem("gmc_details")
    );
  }, []);

  useEffect(() => {
    const company = JSON.parse(localStorage.getItem("company_setup_data"));
    const company_name = localStorage.getItem("company_name");
    if (company) {
      setCompanyName(company?.company_name);
    } else if (company_name) {
      setCompanyName(company_name);
    }
    removeListener();
    (async function () {
      resetCompletedProductList();
      await getEmployeeData();
    })();
  }, []);
  const getEmployeeData = async () => {
    setIsLoading(true);
    try {
      const { data } = await http.get("business/get_ongoing_employees_data/");
      setEmployeeData(data);
      const cutoff_date = data.cutoff_date || "";
      const currentDate = dayjs(),
        cutoff = dayjs(cutoff_date);
      if (
        dayjs(cutoff_date).isBefore(currentDate) &&
        !cutoff.isSame(currentDate)
      ) {
        navigate(`/${routes.UNIVERSAL_PRODUCT_SELECT_UHID}`);
        return;
      }
      !cutoff_date && setShowDownladFields(true);
      setCutoffDate(formatDateSequence(cutoff_date));
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDateChange = (value) => {
    setShowDownladFields(true);
    let newDate = value;
    if (!cutoffDate) {
      setCutoffDate(newDate);
      return;
    }
    let prevDateLen = cutoffDate.length;
    let newDateLen = value.length;
    let newDob = newDate;

    if (newDateLen < prevDateLen) {
      newDob = cutoffDate.substr(0, prevDateLen - 1);
    } else if (newDateLen <= 10) {
      if (newDateLen === 2 || newDateLen === 5) {
        newDob = newDate + "/";
      }
    } else {
      newDob = newDate.slice(0, 10);
    }
    setCutoffDate(newDob);
  };

  const handleSubmit = async () => {
    if (!cutoffDate) {
      setError("Enter a valid Date");
      return;
    }
    const enrollment_id_list = localStorage.getItem("enrollmentIdList");
    const super_task_id = localStorage.getItem("super_task_id");
    const payload = {
      cutoff_date: formatDate(cutoffDate),
      async_task_id: super_task_id,
    };
    try {
      setIsLoading(true);
      const { data } = await http.post(
        "business/update_cut_off_data_for_batch/",
        payload
      );
      await getEmployeeData();
      setShowSnackbar(true);
      setMessage("Cutoff date successfully updated.");
      setShowDownladFields(false);
    } catch (error) {
      if (error.response && error.response.data) alert(error.response.data);
    } finally {
      setIsLoading(false);
    }
  };

  const sendReminder = async () => {
    const { data } = await http.post("business/send_mail_flex/");
    setShowSnackbar(true);
    setMessage("Reminder send successfully.");
  };
  const downloadEmployeeData = async () => {
    const taskset_id = localStorage.getItem("super_task_id");
    const payload = {
      taskset_id,
    };
    const { data } = await http.post(
      "business/download_mis_for_data_collection/",
      payload,
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "collected_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
    console.log({ data });
  };

  return (
    <section>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent onlyShowLogout={!showSidebar} />
          </SideNav>
          <section>
            <BaseSnackbar
              open={showSnackbar}
              handleClose={() => setShowSnackbar(false)}
              message={message}
            />
            <HeaderDasNew company_name={companyName} />
            <MainBody>
              <div style={{ maxWidth: "850px", height: "100%" }}>
                <Ptag fontWeight="700" fontSize="20px">
                  Collect Employee Data
                </Ptag>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div
                    style={{
                      marginTop: "3rem",
                      maxWidth: "350px",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Ptag fontSize="16px" fontWeight="500">
                      Set Cut-off Date
                    </Ptag>
                    <DatefieldWithIcon
                      value={cutoffDate}
                      placeholder="Cutoff Date (DD/MM/YYYY)"
                      error={error}
                      onChange={(e) => handleDateChange(e.target.value)}
                      onSelect={(value) => setShowDownladFields(true)}
                      required
                    ></DatefieldWithIcon>
                    {showDownloadFields && (
                      <div style={{ marginTop: "2rem" }}>
                        <LargeButton
                          type="submit"
                          onClick={handleSubmit}
                          label="Submit"
                          style={{ padding: "1.8rem 0rem", width: "200px" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </MainBody>
          </section>
          <section style={{ borderTop: "1.4rem solid " + "#dadada" }}>
            <MainBody>
              <PageTitle title="Employee Data" />
              <EmployeeDataWrapper>
                <SpiralCompletion
                  relevant_employees={employeeData?.numerator}
                  total_employees={employeeData?.denominator}
                  width="60%"
                  sub_text="Employee Data Submitted"
                />
                <div
                  style={{
                    marginLeft: "8rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* <LargeButton label="Send Reminder" onClick={sendReminder} /> */}
                  <Ptag fontWeight="500" fontSize="20px">
                    Download Employee Data
                  </Ptag>
                  {!showDownloadFields && (
                    <LargeButton
                      type="submit"
                      onClick={downloadEmployeeData}
                      label="Download"
                      style={{
                        marginTop: "24px",
                      }}
                    />
                  )}
                  {/* <LargeButton
                    label="Download Employee Data"
                    onClick={downloadEmployeeData}
                  /> */}
                </div>
              </EmployeeDataWrapper>
            </MainBody>
          </section>
        </>
      )}
    </section>
  );
};

export default FlexDashboard;
